import { productService } from '../_services';

const state = {
  items: [],
  item: null,
  loading: false,
};

const actions = {
  fetchData({ commit }) {
    commit('setLoading', true);
    productService.getItems().then((response) => {
      console.log('Products', response);
      commit('updateData', response.data.results);
    }).finally(() => {
      commit('setLoading', false);
    });
  },
  fetchItem({ commit }, id) {
    commit('setLoading', true);
    return productService.getItem(id).then((response) => {
      commit('updateItem', response.data);
    }).finally(() => {
      commit('setLoading', false);
    });
  },
};

const mutations = {
  // A no-op mutation must be added to serve as a trigger for a reset.
  reset: () => { },
  updateData(state, items) {
    state.items = items;
  },
  updateItem(state, item) {
    state.item = item;
  },
  setLoading(state, isLoading) {
    state.loading = isLoading;
  },
};

// eslint-disable-next-line
export const products = {
  namespaced: true,
  state,
  actions,
  mutations,
};
